export type BrandingColor = {
    name: string;
    value: string;
};

export type Branding = {
    logo?: string;
    colors?: BrandingColor[];
    language?: string;
    companyName?: string;
    isDefault?: boolean;
};

export const defaultBranding = {
    isDefault: true
};